import React from 'react';
import PropTypes from 'prop-types';
import Watermark from '../Watermark';
import './index.scss';

const VariationOutput = ({ outputUrl, backgroundColor = '#fff', withWatermark = false }) => (
    <div className="variation-output-wrapper" style={{ backgroundColor }}>
        {withWatermark && <Watermark/>}
        <img src={outputUrl}/>
    </div>
);

VariationOutput.propTypes = {
    backgroundColor: PropTypes.string,
    outputUrl: PropTypes.string.isRequired,
    withWatermark: PropTypes.bool
};

export default VariationOutput;
